import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { SERVER_URL } from "../util/ServerUtil";
import { useEffect } from "react";

/* Protect a route from unauthenticated users. Check for Firebase auth state */

import { ReactNode } from "react";

interface PatreonRouteProps {
  children: ReactNode;
}

export const PatreonRoute: React.FC<PatreonRouteProps> = ({ children }) => {
  const { accessTier } = useAppContext();

  if (accessTier < 1) {
    return <Navigate to="/profile" />;
  }

  return <>{children}</>;
};
